module.exports = __webpack_public_path__ + "src/img/HD.a9b708b1.svg";